import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/briefbref/Landing";

function App() {
  return (
    <div className="App">
      {/* basename tracks PUBLIC_URL so the same build works whether it's
          deployed at the domain root or under a subpath like /preview —
          CRA already bakes PUBLIC_URL into asset paths, so the router just
          needs to agree with it. Without this, a /preview deploy 404s on
          every route because BrowserRouter assumes it owns "/". */}
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
